import { render } from "./Lists.vue?vue&type=template&id=327ce2ad&scoped=true"
import script from "./Lists.vue?vue&type=script&lang=js"
export * from "./Lists.vue?vue&type=script&lang=js"

import "./Lists.vue?vue&type=style&index=0&id=327ce2ad&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-327ce2ad"

export default script